<template>
  <div id="app">
    <img alt="Vue logo" src="./assets/logo.png">
    <Site msg="Sample Slot using Vue.js/ PIXI.js/ ES6 "/>
  </div>
</template>

<script>
import Site from "./components/Site.vue";

export default {
  name: "app",
  components: {
    Site
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
img {
  width: 125px;
}
</style>
